import * as dayjs from "dayjs";
import * as utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// const KST_TIMEZONE_OFFSET = -540
// const SYSTEM_TIMEZONE_OFFSET = (new Date()).getTimezoneOffset()
// const SYSTEM_TIMEZONE_TO_KST_OFFSET_IN_MILLISECONDS = (SYSTEM_TIMEZONE_OFFSET - KST_TIMEZONE_OFFSET) * 60 * 1000

// const memoizedConvertTimestampToKstStr = () => {
//   const cache = {}
//   return ((timestampInSeconds) => {
//     if(timestampInSeconds in cache) {
//       return cache[timestampInSeconds]
//     } else {
//       if(isNaN(timestampInSeconds)) {
//         return ''
//       }
//       const date = new Date((timestampInSeconds * 1000) + SYSTEM_TIMEZONE_TO_KST_OFFSET_IN_MILLISECONDS)
//       const year = date.getFullYear()
//       const month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
//       const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
//       const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
//       const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
//       const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
//       const result = [year, month, day].join('-') + ' ' + [hour, minute, second].join(':')
//       cache[timestampInSeconds] = result
//       return result
//     }
//   })
// }

const memoizedConvertTimestampToKstStr = () => {
  const cache = {};
  return (timestampInSeconds) => {
    if (timestampInSeconds in cache) {
      return cache[timestampInSeconds];
    } else {
      if (isNaN(timestampInSeconds)) {
        return "";
      }
      const kstStr = dayjs
        .unix(timestampInSeconds)
        .add(9, "hour")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");
      cache[timestampInSeconds] = kstStr;
      return kstStr;
    }
  };
};

export const convertTimestampToKstStr = memoizedConvertTimestampToKstStr();

export const getDistance = (lat1, lon1, lat2, lon2, unit = "K") => {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === "K") {
      dist = dist * 1.609344;
    }
    if (unit === "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }
};

const DEFAULT_EARTHQUAKE_DEPTH = 12.0; // 12 km
const PGA_LEVELS = [
  0.68, 2.25, 7.45, 25.11, 67.29, 144.5, 310.58, 667.17, 1433.63,
];

export const getIntensityFromMag = (
  magnitude,
  distanceInKm,
  hypocenterDepthInKm = DEFAULT_EARTHQUAKE_DEPTH
) => {
  const R = Math.sqrt(distanceInKm ** 2 + hypocenterDepthInKm ** 2);

  /* 조앤박 2001년 식 */
  const ksai0 = [0.1250737e2, 0.4874629, -0.2940726e-1, 0.1737204e-1];
  const ksai1 = [-0.1928185e-2, 0.2251016e-3, -0.6378615e-4, 0.6967121e-4];
  const ksai2 = [-0.5795112, 0.1138817, -0.1162326e-1, -0.3646674e-2];

  /* 조앤박 2003년 식 */
  // const ksai0 = [0.1073829E+02 , 0.5909022E+00, -0.5622945E-01, 0.2135007E-01];
  // const ksai1 = [-0.2379955E-02, 0.2081359E-03, -0.2046806E-04, 0.4192630E-04];
  // const ksai2 = [-0.2437218E+00, 0.9498274E-01, -0.8804236E-02, -0.3302350E-02];

  const c0 =
    ksai0[0] +
    ksai0[1] * (magnitude - 6) +
    ksai0[2] * (magnitude - 6) ** 2 +
    ksai0[3] * (magnitude - 6) ** 3;
  const c1 =
    ksai1[0] +
    ksai1[1] * (magnitude - 6) +
    ksai1[2] * (magnitude - 6) ** 2 +
    ksai1[3] * (magnitude - 6) ** 3;
  const c2 =
    ksai2[0] +
    ksai2[1] * (magnitude - 6) +
    ksai2[2] * (magnitude - 6) ** 2 +
    ksai2[3] * (magnitude - 6) ** 3;

  let lnSA;
  if (R < 100) {
    lnSA = c0 + c1 * R + c2 * Math.log(R) - Math.log(R) - 0.5 * Math.log(100);
  } else if (R > 100) {
    lnSA = c0 + c1 * R + c2 * Math.log(R) - Math.log(100) - 0.5 * Math.log(R);
  } else if (R === 100) {
    lnSA = c0 + c1 * R + c2 * Math.log(R) - Math.log(100) - 0.5 * Math.log(100);
  }

  //qDebug() << c0 << c1 << c2 << R << exp(lnSA) << qLn(lnSA);

  //return exp(lnSA);

  const pga_gal = Math.exp(lnSA);
  let intensity;

  // KMA legend
  if (pga_gal < PGA_LEVELS[0]) {
    intensity = 1;
  } else if (pga_gal < PGA_LEVELS[1]) {
    intensity = 2;
  } else if (pga_gal < PGA_LEVELS[2]) {
    intensity = 3;
  } else if (pga_gal < PGA_LEVELS[3]) {
    intensity = 4;
  } else if (pga_gal < PGA_LEVELS[4]) {
    intensity = 5;
  } else if (pga_gal < PGA_LEVELS[5]) {
    intensity = 6;
  } else if (pga_gal < PGA_LEVELS[6]) {
    intensity = 7;
  } else if (pga_gal < PGA_LEVELS[7]) {
    intensity = 8;
  } else if (pga_gal < PGA_LEVELS[8]) {
    intensity = 9;
  } else {
    intensity = 10;
  }

  return intensity;
};
